<div class="sync-import-dialog">
  <h2 mat-dialog-title>Import Sync</h2>

  <mat-dialog-content class="sync-import-content">
    <div class="file-row">
      <button mat-raised-button color="primary" (click)="manifestInput.click()" [disabled]="importing">
        <mat-icon>description</mat-icon>
        Metadata
      </button>
      <div class="truncate">{{ manifest ? 'metadata.json' : 'No metadata selected' }}</div>
      <input #manifestInput type="file" accept=".json,application/json" (change)="onManifestPicked($event.target.files)">
    </div>

    <div class="file-row">
      <button mat-raised-button color="primary" (click)="filesInput.click()" [disabled]="importing || !manifest">
        <mat-icon>upload_file</mat-icon>
        Files
      </button>
      <div class="truncate">{{ files.length ? files.length + ' files selected' : 'No files selected' }}</div>
      <input #filesInput type="file" multiple (change)="onFilesPicked($event.target.files)">
    </div>

    <div *ngIf="manifest" class="summary">
      {{ manifest.tasks.length }} tasks from {{ manifest.sourceSystem }}
    </div>

    <mat-error *ngIf="manifestError">{{ manifestError }}</mat-error>
    <mat-error *ngIf="fileError">{{ fileError }}</mat-error>

    <mat-progress-bar *ngIf="importing" mode="determinate" [value]="progress"></mat-progress-bar>

    <div *ngIf="results.length" class="results flex-column gap-6">
      <div *ngFor="let result of results" class="result-row">
        <mat-icon>{{ result.status === 'IMPORTED' ? 'check_circle' : 'skip_next' }}</mat-icon>
        <div class="truncate">{{ result.originalFilename }}</div>
        <div>{{ result.status }}</div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="close()" [disabled]="importing">Cancel</button>
    <button mat-raised-button color="primary" (click)="import()" [disabled]="!ready || importing">
      <mat-icon>sync</mat-icon>
      Import
    </button>
  </mat-dialog-actions>
</div>
